import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { configQueryOptions } from '../basic/configQuery';
import { isOneTrustLoadedAtom, hydratedOneTrustActiveGroupsAtom } from './tagManagementStore';
import { useSetAtom } from 'jotai';

const OneTrust: React.FC = () => {
  const setIsOneTrustLoaded = useSetAtom(isOneTrustLoadedAtom);
  const setHydratedOneTrustActiveGroups = useSetAtom(hydratedOneTrustActiveGroupsAtom);
  const config = useQuery(configQueryOptions);
  const oneTrustTagId = 'oneTrustTagId';

  useEffect(() => {
    if (!config.isSuccess)
      return;
    if (document.getElementById(oneTrustTagId) !== null)
      return;

    const script = document.createElement('script');
    script.id = oneTrustTagId;
    script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script.type = 'text/javascript';
    script.setAttribute('data-dLayer-name', 'dataLayerOneTrust');
    script.setAttribute('data-domain-script', config.data.oneTrustDomainScript);
    script.onload = () => {
      setIsOneTrustLoaded(true);
    };
    document.head.appendChild(script);

    const handleEventOneTrustGroupsUpdated = () => {
      setHydratedOneTrustActiveGroups(window.OptanonActiveGroups);
    };

    window.addEventListener('OneTrustGroupsUpdated', handleEventOneTrustGroupsUpdated);
  }, [
    config.isSuccess,
    config.data,
    setHydratedOneTrustActiveGroups,
    setIsOneTrustLoaded,
  ]);

  return <></>;
};

export default OneTrust;
